var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8566 55.5233L44.7133 69.6667C44.0947 70.2858 43.3603 70.777 42.5518 71.1121C41.7433 71.4472 40.8768 71.6197 40.0016 71.6197C39.1264 71.6197 38.2599 71.4472 37.4514 71.1121C36.6429 70.777 35.9085 70.2858 35.2899 69.6667L21.1433 55.5233C17.414 51.7939 14.8744 47.0423 13.8456 41.8695C12.8167 36.6968 13.3449 31.3351 15.3633 26.4624C17.3817 21.5898 20.7996 17.4251 25.1849 14.495C29.5701 11.5649 34.7258 10.001 39.9999 10.001C45.274 10.001 50.4297 11.5649 54.815 14.495C59.2003 17.4251 62.6182 21.5898 64.6366 26.4624C66.655 31.3351 67.1831 36.6968 66.1543 41.8695C65.1255 47.0423 62.5859 51.7939 58.8566 55.5233V55.5233Z",
    stroke: "#D1D5DB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0711 43.7376C48.9464 41.8622 50 39.3187 50 36.6665C50 34.0143 48.9464 31.4708 47.0711 29.5954C45.1957 27.7201 42.6522 26.6665 40 26.6665C37.3478 26.6665 34.8043 27.7201 32.9289 29.5954C31.0536 31.4708 30 34.0143 30 36.6665C30 39.3187 31.0536 41.8622 32.9289 43.7376C34.8043 45.6129 37.3478 46.6665 40 46.6665C42.6522 46.6665 45.1957 45.6129 47.0711 43.7376Z",
    stroke: "#D1D5DB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.a47adf34f4c31244dffc99989a2881e8.svg";
export { ForwardRef as ReactComponent };